/* eslint-disable @angular-eslint/directive-class-suffix */
import {computed, Directive, effect, inject, signal} from '@angular/core';
import {Router} from '@angular/router';
import {interval, merge, of} from 'rxjs';
import {catchError, switchMap, take} from 'rxjs/operators';
import {BackendAppStatus, BackendStatus} from '../model/backend-status';
import {
  BACKEND_STATUS_SERVICE,
  NETWORK_UNAVAILABLE_ROUTE,
  ROOT_ROUTE,
  WAITING_TO_BE_ROUTE
} from '../application-core.providers';
import {HealthcheckService} from '../guards/healthcheck.service';


@Directive()
export abstract class AbstractBackendStatusComponent {

  private backendStatusService = inject(BACKEND_STATUS_SERVICE);
  private healthcheckService = inject(HealthcheckService);
  private router = inject(Router);
  protected rootRoute = inject(ROOT_ROUTE);
  protected waitingToBeRoute = inject(WAITING_TO_BE_ROUTE);
  protected networkUnavailableRoute = inject(NETWORK_UNAVAILABLE_ROUTE);

  protected apiStatus = computed(() => {
    return this.backendAppStatus()
      .filter(app => !app.excludeFromApi)
      .toSorted((a, b) => {
        const an = a.name.toLowerCase();
        const bn = b.name.toLowerCase();
        return (an < bn) ? -1 : (an > bn) ? 1 : 0;
      });
  });

  private backendAppStatus = signal<BackendAppStatus[]>([]);

  private backendStatus = computed(() => {
    return (
      this.backendAppStatus().every(appStatus => appStatus.isRunning || appStatus.excludeFromApi) ?
        BackendStatus.UP :
        BackendStatus.DOWN
    );
  });

  constructor() {
    const beCheckTimer$ = merge(
      of(null),
      interval(5_000).pipe(take(10)),
      interval(60_000),
    );

    beCheckTimer$.pipe(
      switchMap(() => this.backendStatusService.getBackendAppsStatus()),
      catchError(_ => of([])),
    ).subscribe(backendAppStatus => {
      this.backendAppStatus.set(backendAppStatus);
    });

    effect(() => {
      const backendStatus = this.backendStatus();

      if (backendStatus === BackendStatus.UP) {
        this.router.navigateByUrl(this.healthcheckService.lastUsedRoute ?? this.rootRoute);
        this.healthcheckService.lastUsedRoute = null;
      }
      else if (backendStatus === BackendStatus.DOWN) {
        this.router.navigateByUrl(this.waitingToBeRoute);
      }
      else if (backendStatus === BackendStatus.NETWORK_UNAVAILABLE) {
        this.router.navigateByUrl(this.networkUnavailableRoute);
      }
    });
  }

}
